import { useEffect, useState, useRef } from "react";
import axios from "axios";

const useGestoresTipoAprovechamiento = (year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
   

  const fetchData = async () => {
    
    try {
      setLoading(true);
    
      const response = await axios.post(
        `https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerGestoresTipoAprovechamiento`,
        { 
          anio: year, 
          mes: mes, 
          provincia: provinciaSeleccionada || null,  
          ciudad: ciudadSeleccionada || null,       
          id_administrador: idAdministrador 
        },
        { headers: { Authorization: token } }
      );
        
      if (Array.isArray(response.data)) {
        setData(response.data);
      } else if (response.data && response.data.success) {
        setData(response.data.data || []);
      } else {
        console.warn("⚠️ Respuesta inesperada:", response.data);
        setData([]);
      }
      
      setError(null);
    } catch (error) {
      console.error("Error completo:", error);
      setError(error.message || "Error al obtener datos");
      setData([]);
    } finally {
      setLoading(false);
    }
  }

  if (token && idAdministrador) {
    fetchData();
  } else {
     
    setLoading(false);
  }
}, [year, mes, token, provinciaSeleccionada, ciudadSeleccionada, idAdministrador]);
  
  return { data, loading, error };
};

export default useGestoresTipoAprovechamiento;